import {
  REPORTS_ENQUADRAMENTO_REGRAS_CHANGED,
  REPORTS_ENQUADRAMENTOS_CHANGED,
  REPORTS_ENQUADRAMENTO_PARAMS_CHANGED,
  REPORTS_VAR_PARAMS_CHANGED,
  REPORTS_DURATION_PARAMS_CHANGED,
  REPORTS_CONFERENCIACUSTODIANTE_PARAMS_CHANGED,
  REPORTS_STRESSTEST_PARAMS_CHANGED,
  REPORTS_LOGOUT,
} from "../../const/actionsType";

export function acReportsEnquadramentoRegrasChanged(pData) {
  return {
    type: REPORTS_ENQUADRAMENTO_REGRAS_CHANGED,
    payload: pData,
  };
}

export function acReportsEnquadramentosChanged(pData) {
  return {
    type: REPORTS_ENQUADRAMENTOS_CHANGED,
    payload: pData,
  };
}

export function acReportsEnquadramentoParamsChanged(pData) {
  return {
    type: REPORTS_ENQUADRAMENTO_PARAMS_CHANGED,
    payload: pData,
  };
}

export function acReportsVarParamsChanged(pData) {
  return {
    type: REPORTS_VAR_PARAMS_CHANGED,
    payload: pData,
  };
}

export function acReportsDurationParamsChanged(pData) {
  return {
    type: REPORTS_DURATION_PARAMS_CHANGED,
    payload: pData,
  };
}

export function acReportsConferenciaCustodianteParamsChanged(pData) {
  return {
    type: REPORTS_CONFERENCIACUSTODIANTE_PARAMS_CHANGED,
    payload: pData,
  };
}

export function acReportsStresstestParamsChanged(pData) {
  return {
    type: REPORTS_STRESSTEST_PARAMS_CHANGED,
    payload: pData,
  };
}

export function acReportsLogout() {
  return {
    type: REPORTS_LOGOUT,
  };
}
